import { render, staticRenderFns } from "./TransferReservationForm.vue?vue&type=template&id=181549f3&scoped=true&"
import script from "./TransferReservationForm.vue?vue&type=script&lang=js&"
export * from "./TransferReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181549f3",
  null
  
)

export default component.exports